export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    fields: Array,
  },
};
